/**
 * 运行时环境配置。
 *
 * 默认留空 = 同源。开发期由 Vite proxy 把 /api 转到后端，生产期由 Nginx 反代。
 * 这样前端代码里不需要出现任何 host，也就不会出现"换环境要改代码"的问题。
 */
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

export const REQUEST_TIMEOUT_MS = Number(import.meta.env.VITE_REQUEST_TIMEOUT ?? 30000);

/** 拼出完整请求地址：同源时只是路径，跨域时是绝对地址 */
export function apiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}
